export class MobileVerificationResult {
    public verifiedStatus!: string;
    public verificationUrl!: string;
    public sessionCloseUrl!: string;
}
